import {
  EmailAuthProvider,
  getAuth,
  reauthenticateWithCredential,
  signOut,
  updatePassword,
  sendPasswordResetEmail,
} from 'firebase/auth';

export function getAuthErrorMessage(error: unknown): string {
  const code =
    error && typeof error === 'object' && 'code' in error
      ? String((error as { code: string }).code)
      : '';

  switch (code) {
    case 'auth/wrong-password':
    case 'auth/invalid-credential':
      return 'Current password is incorrect.';
    case 'auth/weak-password':
      return 'New password is too weak. Use at least 6 characters.';
    case 'auth/requires-recent-login':
      return 'Please sign out, sign in again, and retry.';
    case 'auth/too-many-requests':
      return 'Too many attempts. Wait a few minutes and try again.';
    case 'auth/user-mismatch':
      return 'Session expired. Sign in again and retry.';
    default:
      return 'Could not update password. Please try again.';
  }
}

export async function changePassword(
  currentPassword: string,
  newPassword: string
): Promise<void> {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user?.email) {
    throw new Error('You must be signed in to change your password.');
  }

  const credential = EmailAuthProvider.credential(user.email, currentPassword);
  await reauthenticateWithCredential(user, credential);
  await updatePassword(user, newPassword);
}

export async function signOutUser(): Promise<void> {
  await signOut(getAuth());
}

export async function sendPasswordReset(email: string): Promise<void> {
  await sendPasswordResetEmail(getAuth(), email);
}
